import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { TranslocoModule } from '@ngneat/transloco';

import { ComponentsModule } from '@core/components/components.module';
import { SharedModule } from '@core/shared.module';

import { CarrierEffects } from '@carrier/state';

import { CarrierLookupDialogComponent } from './carrier-lookup-dialog/carrier-lookup-dialog.component';
import { CarrierLookupDialogGridComponent } from './carrier-lookup-dialog/grid/grid.component';

@NgModule({
  declarations: [CarrierLookupDialogComponent, CarrierLookupDialogGridComponent],
  imports: [CommonModule, SharedModule, ComponentsModule, TranslocoModule, EffectsModule.forFeature([CarrierEffects])],
  exports: [CarrierLookupDialogComponent],
})
export class CarrierModule {}
